export default "__VITE_ASSET__JrR3CxbK__"